module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title9"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("I: In Chinese philosophical terminology: (1) The One, which is engendered by Tao and which in turn engenders the Two ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("yin")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("yang")]), _vm._v(")"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")]), _vm._v(" (Lao Tzu.) (2) Unity of mind, “not allowing one impression to harm another.” (3) The number for Heaven, as two is the number for Earth. (4) Righteousness, justice; one of the four Confucian Fundamentals of the Moral Life ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("ssu tuan")]), _vm._v(") and the Five Constant Virtues ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("wu ch’ang")]), _vm._v("). It is the virtue “by which things are made proper,” “by which the world is regulated.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I Ching:")]), _vm._v(" The Book of Changes (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I Yuan:")]), _vm._v(" In Chinese philosophy, the One-Prime which is the supreme beginning. It is One and is identical with the Origin. “The Prime is the root of the myriad things, in which there is also the origin of Man.” (Tung Chung-shu, 177–104 B.C.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Iblis:")]), _vm._v(" The Moslem equivalent of Satan; the prince of fallen angels who was turned into a devil.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ichthyomancy:")]), _vm._v(" Divination by examining the entrails of fishes.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ideoplasm:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ectoplasm")]), _vm._v(" (q.v.) molded into the likeness of a self.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Idol:")]), _vm._v(" An image or representation of a supernatural being, in which the latter is believed to have his seat or abode, and before which sacrifices and other acts and rituals of worship are performed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Idolatry:")]), _vm._v(" The worship of a physical object as a god.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ifrit:")]), _vm._v(" A viciously malignant spirit, of hideous appearance, in Arabic folklore.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Igigi:")]), _vm._v(" A Babylonian term for the gods or spirits of heaven in general, or specifically, for the gods or spirits embodied in those stars which were above the horizon at any one time.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ignis fatuus:")]), _vm._v(" The luminous appearance frequently observed in marshy places, swamps, cemeteries, etc., explained by spiritualists to be apparitions of spirits of the dead, and by adherents to materialistic science as gaseous emanations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IHVH:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tetragrammaton.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Illuminati:")]), _vm._v(" The plural of the Latin "), _c('em', {
    staticClass: "i"
  }, [_vm._v("illuminatus,")]), _vm._v(" meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("enlightened one.")]), _vm._v(" While the term is generally used in occultism to designate all those who have “seen the higher light,” it has been used in history as a specific designation of various sects and societies, especially the Rosicrucians and the Martinists of the 18th century. A sect under this name was founded by Adam Weishaupt in Germany in 1776.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Illumination, Stage of:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Illuminatus:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("enlightened")]), _vm._v(" (plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Illuminati")]), _vm._v("—q.v.). In esoteric terminology, an adept or initiate.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Illusion:")]), _vm._v(" An illusion of sense is an erroneous perception arising from a misinterpretation of data of sense because they are produced under unusual conditions of perception, physical, physiological or psychological. Illusion contrasts with hallucination in which the sensuous ingredients are totally absent. In occult terminology, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("illusion")]), _vm._v(" is a synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("maya")]), _vm._v(" (q.v.), and thus applicable to everything finite.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Image:")]), _vm._v(" In Rosicrucian parlance, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("to image")]), _vm._v(" means to recollect or to produce mental images. (Not synonymous with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("to imagine!")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imageless thought:")]), _vm._v(" Conceptual meanings not embodied in sensuous imagery.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imagery:")]), _vm._v(" Mental images or sounds heard “within the mind.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imaging:")]), _vm._v(" The Rosicrucian term for the recollection or “reproduction” of mental images. (The verb is "), _c('em', {
    staticClass: "i"
  }, [_vm._v("to image")]), _vm._v(".) Not synonymous with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("imagining.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imaguncula:")]), _vm._v(" An image made of clay, wax, wood, etc., used by practitioners of black magic, witchcraft and sorcery. (Plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Imagunculae")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imhetep:")]), _vm._v(" An ancient Egyptian god, frequently invoked by magicians to aid in exorcisms.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imitative magic:")]), _vm._v(" Magic based on the belief that things which resemble each other can exert an influence over each other—for instance, that a person can be injured by damaging an effigy made to resemble him.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immanence:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("in-dwelling.")]), _vm._v(" In general philosophical terminology, this term refers to an activity producing its effects from within, or to an entity whose being within something else contributes to the existence of the latter. In theology, the term refers to the complete or partial identification of the Deity with the world. (The belief in the absolute immanence of God in the universe is equivalent to pantheism.) Mysticism in its broadest sense posits the mutual immanence of the human and the divine.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immediacy of knowledge:")]), _vm._v(" Knowledge gained without mediation, as self-evident or without interpretation and inference.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immortality:")]), _vm._v(" The imperishability of individual existence; survival or reincarnation after the death of the body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immovability, Stage of:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immutability:")]), _vm._v(" Changelessness, or the state or quality of not being susceptible to any alteration.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imp:")]), _vm._v(" A dwarfish demon. The emissaries of Satan, aiding sorcerers and witches, are usually referred to as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Satanic imps")]), _vm._v(" and are believed to be able to assume any form at will.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Impeded:")]), _vm._v(" A synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("impedited")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Impedited:")]), _vm._v(" An astrological term, applied to a luminary or planet when badly aspected, especially by the malefics. Also said of the Moon when passing to a conjunction, square or opposition to the Sun, Mars, or Saturn. (The Moon when impedited by the Sun at birth was believed by the ancients to produce a blemish in or near the eye.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Impersonation:")]), _vm._v(" Imitation of a deceased person by a medium, by assuming his physical characteristics, voice and mannerisms.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Imum Cœli:")]), _vm._v(" In astrological terminology, the lowest heaven, the North Angle or cusp of the Fourth House.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inari:")]), _vm._v(" Deities of food and fertility in Shintoism.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Incantation:")]), _vm._v(" Any phrase or formula spoken, sung or chanted as a part of a ritual of magic.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Incarnate:")]), _vm._v(" Living in a physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Incarnation:")]), _vm._v(" Life in a physical body; the assumption of a physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inclination:")]), _vm._v(" Astrologically, the motion of a body toward a position in the horoscope other than the one it held at birth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inconjunct:")]), _vm._v(" Astrologers call a planet inconjunct when it forms no aspect and is not in parallel of declination or mutual disposition to another planet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Incubus:")]), _vm._v(" A term generally applied to designate a demon, astral form of a dead person or of a sorcerer, which has sexual intercourse with mortal women.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Indeterminism:")]), _vm._v(" The theory that volitional decisions are in certain cases independent of antecedent physiological and psychological causation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Individuality:")]), _vm._v(" In esoteric philosophy, the divine, impersonal and immortal higher Ego of man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Indra:")]), _vm._v(" The Vedic god of war, storm and fertility, god of the atmosphere and sky, reigning over the deities of the intermediate region or atmosphere.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Indriya:")]), _vm._v(" One of five or more sensory functions or “senses,” conceived generally in Indian philosophy kinetically as powers subservient to "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manas")]), _vm._v(" (q.v.). A common division is into the quintads of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("karmendriyas")]), _vm._v(" (q.v.) and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("jnanendriyas")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ineffable Name:")]), _vm._v(" In mysticism and occultism, the true name of God which must not be pronounced.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inescation:")]), _vm._v(" The occult medical practice aimed at ridding a human being of an illness by transferring it onto an animal.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inferior planets:")]), _vm._v(" In astrology, the minor planets, those whose orbits are within that of the Earth; viz., Mercury and Venus.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inferior world:")]), _vm._v(" In Kabalistic and occult terminology, the world of matter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Infernal empire:")]), _vm._v(" The term generally used in demonography for the organization of the demons under the rule of Beelzebub, in whose "), _c('em', {
    staticClass: "i"
  }, [_vm._v("infernal court")]), _vm._v(" various demons hold ranks of princes, knights, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Infinite:")]), _vm._v(" Completely free of limitations, in all respects.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Infinity:")]), _vm._v(" An endless extent of space, time, or any series. Is usually conceived negatively, as having no termination; may be conceived positively, in respect to reality as actually extending without end.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Influence:")]), _vm._v(" In mediumistic terminology, this term is used as a synonym for “spirit” (in the mediumistic sense of the word).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Information:")]), _vm._v(" In scholastic terminology, the function of form when it perfects the matter united to it so as to constitute a specific body. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("materialization")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Infortunes:")]), _vm._v(" The term applied by astrologers to the planets Mars and Saturn.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Initiate:")]), _vm._v(" One admitted to knowledge of occult mysteries and secrets; one who has acquired occult powers by systematically developing his superphysical capacities.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Initiation:")]), _vm._v(" Admission to one of the formal degrees or classifications in an esoteric or occult discipline.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inner Light:")]), _vm._v(" In the terminology of the Society of Friends (Quakers), the capacity inherent in all men to listen to God speaking to the listening soul, to make satisfying spiritual contact with God, and to understand and share spiritual experience.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inner man:")]), _vm._v(" In occult terminology, the immortal essence or higher ego of man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Inspiration:")]), _vm._v(" A state of psychic receptivity to creative spiritual influence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Integration:")]), _vm._v(" The act of making a whole out of parts. In psychology, the combination of psycho-physical elements into a complex unified organization.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Intellect:")]), _vm._v(" The cognitive faculty of the mind as it operates at higher abstract and conceptual levels.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Intelligence:")]), _vm._v(" The capacity of the mind to meet effectively—through the employment of memory, imagination and conceptual thinking—the practical and theoretical problems with which it is confronted. Intelligence is more inclusive than intellect which is primarily conceptual.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Internal alchemy:")]), _vm._v(" The deification of man’s spirit.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Internal sense:")]), _vm._v(" The mind’s ability to scrutinize reflectively its own inner operations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Interrogation:")]), _vm._v(" In occult terminology, the act or practice of consulting an astrologer medium, oracle, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Intichiuma:")]), _vm._v(" A rite of natives of central Australia, consisting of ceremonies designed to assure the annual supply of food and drink, including rain-making ceremonies.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introspection:")]), _vm._v(" The observation of the presentations and processes of one’s own consciousness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Insufflation:")]), _vm._v(" A practice of occult medicine, consisting in breathing for a certain time upon a person or animal.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Intuition:")]), _vm._v(" The faculty or ability to be aware of facts, knowledge of which would or could not be conveyed by normal reasoning processes. The direct and immediate apprehension by a knowing subject of itself, of its conscious states, of other minds, of an external world, of universals, of values or of rational truths.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Invisible fellowship:")]), _vm._v(" “The interconnections established among men through common motives and ultimate goals as in contrast with their ties through the structures of a surface society; the subjective side of occult functioning; shared immortality.” (Marc Edmund Jones.) See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Great White Brotherhood.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Invocation:")]), _vm._v(" In the terminology of magic, the act or the formula of calling for the presence of a superhuman entity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Involution:")]), _vm._v(" In occult philosophy, a stage or process which precedes evolution and can be regarded as a process inverse to evolution and as manifesting itself in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("descending arc")]), _vm._v(" (q.v.). “The anterior rolling or coiling which, upon reversal, becomes evolution.” (Marc Edmund Jones.) G. A. Gaskell calls it “the descent of Spirit into matter.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Iron Age:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kali Yuga")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Irroration:")]), _vm._v(" In occult medicine, the practice of watering a plant with the discharge of a sick person, to rid the patient of the disease by transferring it to the plant.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ishtar:")]), _vm._v(" The Babylonian goddess of fertility.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ishwara:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("independent being.")]), _vm._v(" The personalized God, first stage in the manifestation of Brahman. Ishwara manifests himself in three aspects: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Brahma,")]), _vm._v(" the Creator, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Vishnu,")]), _vm._v(" the Preserver, and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Shiva,")]), _vm._v(" the Destroyer.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Isis:")]), _vm._v(" Wife of Osiris, greatest of all goddesses of ancient Egypt, “the Great Enchantress, the Mistress of Magic, the Speaker of Spells.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Isis-Osiris mysteries:")]), _vm._v(" Egyptian mysteries (q.v.) which were practiced widely around the Mediterranean, commemorating the death and resurrection of Osiris.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Iswara:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ishwara.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee7abc2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c09.vue
// module id = 99
// module chunks = 0